/** Data curta: "14 out". Com o ano quando não é o atual: "14 out 2025". */
export function shortDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const sameYear = d.getFullYear() === new Date().getFullYear();
  return d
    .toLocaleDateString('pt-BR', { day: 'numeric', month: 'short', ...(sameYear ? {} : { year: 'numeric' }) })
    .replace('.', '')
    .replace(' de ', ' ')
    .replace(' de ', ' ');
}

/** Data da leitura: "14 out 2026". */
export function longDate(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('pt-BR', { day: 'numeric', month: 'short', year: 'numeric' })
    .replace('.', '').replace(/ de /g, ' ');
}

/** "agora", "há 40 min", "há 2 h", "há 3 dias" ou a data curta. */
export function relativeTime(iso) {
  if (!iso) return '';
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return 'agora';
  if (diff < 3600) return `há ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `há ${Math.floor(diff / 3600)} h`;
  if (diff < 7 * 86400) {
    const days = Math.floor(diff / 86400);
    return days === 1 ? 'ontem' : `há ${days} dias`;
  }
  return shortDate(iso);
}

/** Nome curto do curso para a linha de meta: "Software Arch.", "Frontend Eng.". */
export function courseShort(name) {
  if (!name) return '';
  const words = name.split(/\s+/);
  if (name.length <= 14 || words.length < 2) return name;
  const last = words[words.length - 1];
  return `${words.slice(0, -1).join(' ')} ${last.slice(0, 4)}.`;
}

export function slugify(text) {
  return (text || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-+|-+$)/g, '');
}

/** Títulos de seção (## ...) do Markdown, para o sumário. Ignora os que estão dentro de blocos de código. */
export function headingsOf(markdown) {
  const out = [];
  let inCode = false;
  (markdown || '').split('\n').forEach(line => {
    if (/^\s*```/.test(line)) inCode = !inCode;
    if (inCode) return;
    const m = /^##\s+(.+?)\s*#*\s*$/.exec(line);
    if (m) out.push({ text: m[1].replace(/[*_`]/g, ''), id: slugify(m[1]) });
  });
  return out;
}

export function wordCount(markdown) {
  const text = (markdown || '').replace(/```[\s\S]*?```/g, ' ').trim();
  return text ? text.split(/\s+/).length : 0;
}

/** ~200 palavras por minuto, como no backend. */
export const readingMinutes = (words) => Math.max(1, Math.ceil(words / 200));

/** Link do artigo: o público abre sem login (/a/slug); o "Só alunos", o interno. */
export function articleUrl(article) {
  const path = article.visibility === 'public' ? `/a/${article.slug}` : `/artigos/${article.slug}`;
  return `${window.location.origin}${path}`;
}
